export const PAGE_SIZE = 10;
export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 25, 50];
/** @deprecated Use pageSize state with DEFAULT_PAGE_SIZE instead */
export const ADMIN_PAGE_SIZE = DEFAULT_PAGE_SIZE;

const DEFAULT_LIST_KEYS = ['results', 'plans', 'withdrawals', 'items', 'transactions', 'data'];

/**
 * Normalize paginated API responses ({ success, results, page, total_pages, ... }).
 */
export function parsePaginatedResponse(data, listKeys = DEFAULT_LIST_KEYS) {
  let items = [];
  if (Array.isArray(data)) {
    items = data;
  } else if (data && typeof data === 'object') {
    for (const key of listKeys) {
      if (Array.isArray(data[key])) {
        items = data[key];
        break;
      }
    }
  }

  const totalPages = Math.max(1, Number(data?.total_pages) || 1);
  const page = Math.min(Math.max(1, Number(data?.page) || 1), totalPages);

  return {
    items,
    page,
    totalPages,
    count: Number(data?.count) ?? items.length,
    hasNext: Boolean(data?.has_next),
    hasPrevious: Boolean(data?.has_previous),
  };
}

export function shouldShowPagination(totalPages, itemCount) {
  // Show page controls whenever there is data (single-page lists still get the bar pattern).
  return itemCount > 0 && Math.max(1, Number(totalPages) || 1) >= 1;
}

/** Build page list with ellipsis, e.g. [1, 'ellipsis', 8, 9, 10, 'ellipsis', 12] */
export function getVisiblePageNumbers(currentPage, totalPages, siblingCount = 2) {
  const total = Math.max(1, Number(totalPages) || 1);
  const current = Math.min(Math.max(1, Number(currentPage) || 1), total);

  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const pages = new Set([1, total]);
  for (let i = current - siblingCount; i <= current + siblingCount; i += 1) {
    if (i >= 1 && i <= total) pages.add(i);
  }

  const sorted = [...pages].sort((a, b) => a - b);
  const result = [];

  sorted.forEach((pageNum, index) => {
    if (index > 0 && pageNum - sorted[index - 1] > 1) {
      result.push('ellipsis');
    }
    result.push(pageNum);
  });

  return result;
}

/** Client-side slice for lists that load all rows in memory. */
export function paginateClientList(items, page, pageSize) {
  const list = Array.isArray(items) ? items : [];
  const size = Math.max(1, Number(pageSize) || DEFAULT_PAGE_SIZE);
  const totalPages = Math.max(1, Math.ceil(list.length / size));
  const safePage = Math.min(Math.max(1, Number(page) || 1), totalPages);
  const start = (safePage - 1) * size;

  return {
    items: list.slice(start, start + size),
    page: safePage,
    totalPages,
    count: list.length,
  };
}
